import Vue, {PropType} from 'vue'

export const IModalComponentProps = Vue.extend({
    props: {
        title: {
            required: true,
            type: String
        },
        show: {
            required: true,
            type: Boolean
        },
        onOk: {
            required: true,
            type: Function as PropType<() => void>
        },
        subtitle: {
            required: false,
            type: String
        },
        okTitle: {
            required: false,
            type: String,
            default: 'Сохранить'
        },
        cancelTitle: {
            required: false,
            type: String,
            default: 'Отмена'
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
        classModificator: {
            required: false,
            type: String
        },
        busy: {
            required: false,
            type: Boolean
        }
    }
})